import http from '@/services/http';

export const showarquivoAtividadeLiberacaoRequest = (empresa_id, competencia) => {
  return http.get(`/arquivo-atividade/${empresa_id}`, {
    params: {competencia}
  })
}

export const uploadArquivoAtividadeRequest = (payload) => {
  return http.post('/arquivo-atividade/upload', payload)
};

export const arquivoAtividadeCreateRequest = (payload) => {
  return http.post(`/arquivo-atividade`, payload);
};
export const arquivoAtividadeUpdateRequest = (payload) => {
  return http.put(`/arquivo-atividade/`+payload.arquivoAtividade_id, payload);
};
export const arquivoAtividadeDeleteRequest = (payload) => {
  return http.put(`/arquivo-atividade/delete/`+payload.arquivoAtividade_id, payload);
};

export const arquivoAtividadeRequest = () => {
  return http.get(`/arquivo-atividade`);
};

export const arquivoAtividadeNotaFiscalRequest = (payload) => {
  return http.post(`/arquivo-atividade/notafiscal/` +payload.id ,payload);
};

export const arquivoAtividadeNaoProcessadasRequest = () => {
  return http.get('/arquivo-atividade/nao-processadas');
};

export const chageLiberacaoRequest = (payload) => {
  return http.post('/arquivo-atividade/change-liberacao', payload);
};

export const deleteArquivoAtividadeNaoProcessadaRequest = (id) => {
  return http.delete('/arquivo-atividade/nao-processadas/' + id);
};

export const tiposArquivoAtividadeRequest = () => {
  return http.get('/arquivo-atividade/tipos');
};

export const estornarArquivoAtividadeRequest = (arquivoAtividade) => {
  return http.put('/arquivo-atividade/estorno/' + arquivoAtividade.arquivo_atividade_id ,arquivoAtividade);
};


export const getUploadReport = () => {
  return http.get(`arquivoAtividade/upload-report`)
}
